import { Message } from 'element-ui'
import axios from 'axios'
// axios.defaults.baseURL = 'http://xingzhili.b.langqiyun.cn/'
axios.interceptors.response.use(
    response => {
        if (response.data.code !== 200) {
            Message.error(response.data.msg)
        }
        return response.data
    }
)
const request = {
    post: (api, data) => {
        api = 'api/' + api
        return new Promise((resolve, reject) => {
            axios.post(api, data).then(r => {
                resolve(r)
            })
        })
    },
    get: (api, data) => {
        api = 'api/' + api
        return new Promise((resolve, reject) => {
            axios.get(api, {
                params: data
            }).then(r => {
                resolve(r)
            })
        })
    }
}
export default request